import { httpDelete, httpGet, httpPatch, httpPost } from "@/api/connection";
import {
  AssignStorageToCaseFn,
  CreateStorageFn,
  DeleteStorageFn,
  ExportStorageListFn,
  GetStorageItemsFn,
  GetStorageModelNumbersFn,
  GetStorageModelsFn,
  GetStorageProvidersFn,
  GetStorageTypesFn,
  MoveStorageItemsFn,
  QueryStorageItemsFn,
  RemoveStorageFromCaseFn,
  UpdateStorageFn,
} from "./storage.api.types";

const createStorage: CreateStorageFn = async (values) => {
  return await httpPost("/storage/items", values);
};

const updateStorage: UpdateStorageFn = async (storage_id, values) => {
  return await httpPatch(`/storage/items/${storage_id}`, values);
};

const deleteStorage: DeleteStorageFn = async ({ storage_id }) => {
  return await httpDelete(`/storage/items/${storage_id}`);
};

const queryStorage: QueryStorageItemsFn = async (query) => {
  // Legacy POST /storage/query envelope — resolveStorageQuery.ts documents
  // this temporary bridge.
  return await httpPost("/storage/query", query);
};

const exportStorageList: ExportStorageListFn = async (options) => {
  return await httpPost("/storage/export", options);
};

const getStorage: GetStorageItemsFn = async (query = {}) => {
  // The legacy CaseStorageAPI.getStorage unwrapped the `.data` envelope;
  // repointed callers depend on receiving the bare item array.
  return (await httpGet("/storage/items", query)).data;
};

const moveStorageItems: MoveStorageItemsFn = async (values) => {
  return await httpPatch("/storage/items/move-items", values);
};

const assignStorageToCase: AssignStorageToCaseFn = async (data) => {
  return await httpPost("/storage/items/assign", data);
};

const removeStorageFromCase: RemoveStorageFromCaseFn = async (data) => {
  return await httpPost("/storage/items/unassign", data);
};

const getTypes: GetStorageTypesFn = async () => {
  return await httpGet("/storage/types");
};

const getProviders: GetStorageProvidersFn = async () => {
  return await httpGet("/storage/brands");
};

const getStorageModels: GetStorageModelsFn = async () => {
  return await httpGet("/storage/models");
};

const getStorageModelNumbers: GetStorageModelNumbersFn = async () => {
  return await httpGet("/storage/model-numbers");
};

export const StorageAPI = {
  create: createStorage,
  update: updateStorage,
  delete: deleteStorage,
  query: queryStorage,
  exportStorageList,
  getStorage,
  moveStorageItems,
  assignStorageToCase,
  removeStorageFromCase,
  getTypes,
  getProviders,
  getStorageModels,
  getStorageModelNumbers,
};
